
<div id="login" class="bg-primary">
  <div>
    <h1 class="color-primary app-name" > UPservice </h1>
    <img class="logo-splash" src="assets/logo/logo_brand_white.svg" alt="Legrand Logo"> <br>
    <div class="row my-4">
      <div class="ups-spacer"></div>
      <div class="spinner-border color-accent align" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="ups-spacer"></div>
    </div>

  </div>
</div>
